// Automatically loads every image file from a gallery category folder —
// drop a new photo into src/assets/gallery/<category>/ and it appears here
// with no code changes needed.

type RequireContext = {
  keys(): string[];
  (id: string): string;
};

// Locally declare require.context so this compiles even if @types/node
// isn't installed — webpack (react-scripts) provides the real thing at
// build/runtime regardless of what TypeScript knows about it here.
declare const require: {
  context(
    directory: string,
    useSubdirectories: boolean,
    regExp: RegExp
  ): RequireContext;
};

function importAll(context: RequireContext): string[] {
  return context
    .keys()
    .filter((key) => !/cover/i.test(key)) // cover.jpg is only for the entry tile, not the gallery scroll
    .sort() // stable, predictable order (alphabetical by filename)
    .map((key) => context(key));
}

export function loadTravelImages(): string[] {
  const context = require.context(
    './assets/gallery/travel',
    false,
    /\.(jpe?g|png|webp)$/i
  );
  return importAll(context);
}

export function loadPortraitsImages(): string[] {
  const context = require.context(
    './assets/gallery/portraits',
    false,
    /\.(jpe?g|png|webp)$/i
  );
  return importAll(context);
}

export function loadStreetImages(): string[] {
  const context = require.context(
    './assets/gallery/street',
    false,
    /\.(jpe?g|png|webp)$/i
  );
  return importAll(context);
}